import {Container, Row, Col} from "react-bootstrap";
import Products from "../../../components/monaliza/product/Products";
import {Empty} from "antd"

const CartList = () => {




  return (
    <>
      <Container>
        <Row>
          <Col className="d-flex align-items-center justify-content-center" style={{height: "60vh"}}>
            <Empty description="No data" className="fw-bold"/>
          </Col>
          {/* <h1>В корзине {5} товара</h1> */}
          {/* <Products shape={"Kanban"} /> */}
        </Row>
      </Container>
    </>
  );
};

export default CartList;
